import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 1.5rem 0;

  @media (max-width: 768px) {
    padding: 1rem 0;
  }
`;

export const HeaderCard = styled.div`
  margin-bottom: 1.5rem;

  .card {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    color: #009ef7;
    flex-shrink: 0;
  }

  h4 {
    margin: 0 0 0.25rem 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #181c32;
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    color: #7e8299;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    
    h4 {
      font-size: 1.1rem;
    }

    p {
      font-size: 0.813rem;
    }
  }
`;

export const InfoCardsRow = styled.div`
  margin-bottom: 1.5rem;

  .card {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
    }
  }
`;

export const InfoCard = styled.div`
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const InfoCardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const IconCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.bg-primary {
    background-color: rgba(0, 158, 247, 0.1);
    color: #009ef7;
  }

  &.bg-info {
    background-color: rgba(23, 162, 184, 0.1);
    color: #17a2b8;
  }

  &.bg-success {
    background-color: rgba(40, 167, 69, 0.1);
    color: #28a745;
  }
`;

export const InfoLabel = styled.div`
  font-size: 0.75rem;
  color: #7e8299;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
`;

export const InfoValue = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #181c32;
  margin-bottom: 0.125rem;
`;

export const InfoSubtext = styled.div`
  font-size: 0.75rem;
  color: #a1a5b7;
`;

export const ActionCard = styled.div`
  margin-bottom: 1.5rem;

  .card {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const ActionTitle = styled.h5`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #181c32;

  svg {
    color: #009ef7;
  }
`;

export const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const StepItem = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
`;

export const StepBadge = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #009ef7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
`;

export const StepTitle = styled.div`
  font-size: 0.938rem;
  font-weight: 600;
  color: #181c32;
  margin-bottom: 0.25rem;
`;

export const StepDescription = styled.div`
  font-size: 0.875rem;
  color: #7e8299;
  line-height: 1.5;
`;

export const ResultsCard = styled.div`
  margin-bottom: 1.5rem;

  .card {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const ResultsTitle = styled.h5`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #181c32;

  svg {
    font-size: 1.25rem;
  }
`;

export const StatCard = styled.div`
  padding: 1.25rem;
  border-radius: 0.5rem;
  text-align: center;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const StatValue = styled.div`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const StatLabel = styled.div`
  font-size: 0.813rem;
  color: #7e8299;
  font-weight: 500;
`;

export const ProgressWrapper = styled.div`
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eff2f5;
`;

export const ProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: #7e8299;
  font-weight: 500;
`;

export const TableCard = styled.div`
  margin-bottom: 1.5rem;

  .card {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const TableTitle = styled.h5`
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #181c32;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;

  .table {
    margin-bottom: 0;

    thead {
      background-color: #f9fafb;
      
      th {
        font-size: 0.813rem;
        font-weight: 600;
        color: #7e8299;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        border-bottom: 2px solid #eff2f5;
        padding: 0.75rem 1rem;
        white-space: nowrap;
      }
    }

    tbody {
      tr {
        transition: background-color 0.15s ease;

        &:hover {
          background-color: #f9fafb;
        }

        td {
          padding: 1rem;
          vertical-align: middle;
          border-bottom: 1px solid #eff2f5;
          font-size: 0.875rem;
        }
      }
    }
  }

  .badge {
    padding: 0.375rem 0.75rem;
    font-weight: 500;
    font-size: 0.813rem;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
  }

  @media (max-width: 768px) {
    .table {
      font-size: 0.813rem;

      thead th,
      tbody td {
        padding: 0.625rem 0.75rem;
      }
    }

    .badge {
      font-size: 0.75rem;
      padding: 0.25rem 0.5rem;
    }
  }
`;

export const ProductName = styled.div`
  font-weight: 600;
  color: #181c32;
  margin-bottom: 0.25rem;
  line-height: 1.4;
`;

export const ProductId = styled.div`
  font-size: 0.75rem;
  color: #a1a5b7;
`;